'use client';

import type { LiveRankingType } from '@module/apis/client-side/live/type';
import { getRankingFilterList, RankingTypeSortedByLive } from '@module/helpers/ranking/rankingFilter';
import useRankingViewModel from '@module/helpers/ranking/useRankingViewModel';
import { cn } from '@module/lib/utils';
import useModalStore from '@module/stores/useModalStore';
import { BaseHttpResponseError } from '@module/utils/error/apiErrors';
import Link from 'next/link';
import { Fragment } from 'react';

interface Props {
  searchType: LiveRankingType;
}

function RankingFilterBar({ searchType }: Props) {
  const { pushModal, popModal } = useModalStore();
  const { data } = useRankingViewModel({
    searchType,
    limitPerQuery: 20,
    errorHandler: (error: unknown) => {
      if (error instanceof BaseHttpResponseError) {
        pushModal({
          type: 'CONFIRM_MODAL',
          id: 'useRankingViewModel',
          options: {
            description: error.message,
            onClose: popModal,
          },
        });
        return;
      }
      pushModal({
        type: 'CONFIRM_MODAL',
        id: 'useRankingViewModel',
        options: {
          description: '알수없는 오류로 요청이 실패하였습니다.',
          onClose: popModal,
        },
      });
    },
  });

  return (
    <div className='mt-[30px] mb-4 flex items-center justify-between' data-testid='ranking-period-filter'>
      <div className='font-normal text-[#777] text-[15px]'>
        {!RankingTypeSortedByLive.includes(searchType) &&
          searchType !== 'rankingPopularMonth' &&
          `랭킹은 1시간마다 업데이트 됩니다. ${data ? `${data?.pages[0]?.lastUpdateTime} 기준` : ''}`}
        {searchType === 'rankingPopularMonth' &&
          `랭킹은 24시간마다 업데이트 됩니다. ${data ? `${data?.pages[0]?.lastUpdateTime} 기준` : ''}`}
      </div>
      <div className='flex items-center text-baseFg'>
        {getRankingFilterList(searchType).map((l, idx) => (
          <Fragment key={l.searchType}>
            {idx > 0 && <div className='mx-2.5 h-4 w-[1px] bg-borderBg07' />}
            <Link
              prefetch={false}
              className={cn({
                'font-bold': searchType === l.searchType,
              })}
              href={`/ranking/${l.searchType}`}
            >
              {l.sortBy === 'popular' && '인기순'}
              {l.sortBy === 'live' && '실시간'}
              {l.sortBy === 'month' && '월간'}
            </Link>
          </Fragment>
        ))}
      </div>
    </div>
  );
}

export default RankingFilterBar;
